import { io, type Socket } from 'socket.io-client';
import type { WidgetConfig } from '../ui/types.js';

export function connect(config: WidgetConfig, token: string): Socket {
  return io(config.apiUrl, {
    auth: { token },
    transports: ['websocket'],
    reconnection: true,
    reconnectionDelay: 500,
    reconnectionDelayMax: 5000,
  });
}
